import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[tiClickOutside]',
})
export class ClickOutsideDirective {
  @Input() isAvoidFirstClick: boolean;
  @Input() excludeElement: ElementRef | HTMLElement | null = null;
  @Output() clickOutside = new EventEmitter();

  constructor(private elementRef: ElementRef) {}

  private isEventInside(e: MouseEvent): boolean {
    const root = this.elementRef.nativeElement as Node;
    const target = e.target;
    if (target && root.contains(target as Node)) {
      return true;
    }
    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];

    if (path.includes(root)) {
      return true;
    }

    if (this.excludeElement) {
      const excludeNode = this.excludeElement instanceof ElementRef
        ? this.excludeElement.nativeElement
        : this.excludeElement;

      if (excludeNode && (excludeNode.contains(target as Node) || path.includes(excludeNode))) {
        return true;
      }
    }

    return false;
  }

  @HostListener('document:mousedown', ['$event']) onClick(e: MouseEvent) {
    if (this.isAvoidFirstClick) {
      this.isAvoidFirstClick = null;
      return;
    }
    if (!this.isEventInside(e)) {
      this.clickOutside.emit(e);
    }
  }
}
